import { c as _c } from "react/compiler-runtime";
import type { SavedAddress } from '@newfront-insurance/address-api';
import type { JSX } from 'react';
import { AddressInput } from '../../internals/components/address-input';
import { SmartyStreetsProvider } from '../../providers/smartystreets';
import { SmartyStreetsInternationalProvider } from '../../providers/smartystreets-international';
import { SMARTY_STREETS_AUTOCOMPLETE_PUBLIC_KEY } from '../../utils/smarty-street-public-key';
interface Props {
  accountUuid: string;
  onChange: (address?: SavedAddress) => unknown;
  selectedAddress?: SavedAddress;
  disabled?: boolean;
  width?: number | string;
  disableCloseCustomAddressModalOnEscape?: boolean;
}
export function AddressSelector(t0) {
  const $ = _c(7);
  const {
    accountUuid,
    onChange,
    selectedAddress,
    disabled,
    width,
    disableCloseCustomAddressModalOnEscape
  } = t0;
  let t1;
  if ($[0] !== accountUuid || $[1] !== disableCloseCustomAddressModalOnEscape || $[2] !== disabled || $[3] !== onChange || $[4] !== selectedAddress || $[5] !== width) {
    t1 = <SmartyStreetsInternationalProvider apiKey={SMARTY_STREETS_AUTOCOMPLETE_PUBLIC_KEY}><SmartyStreetsProvider apiKey={SMARTY_STREETS_AUTOCOMPLETE_PUBLIC_KEY}><AddressInput accountUuid={accountUuid} selectedAddress={selectedAddress} onChange={onChange} disabled={disabled} width={width} disableCloseCustomAddressModalOnEscape={disableCloseCustomAddressModalOnEscape} /></SmartyStreetsProvider></SmartyStreetsInternationalProvider>;
    $[0] = accountUuid;
    $[1] = disableCloseCustomAddressModalOnEscape;
    $[2] = disabled;
    $[3] = onChange;
    $[4] = selectedAddress;
    $[5] = width;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}